module.exports = function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/html-to-react/~/ramda/src/internal/_isTransformer.js
// module id = 655
// module chunks = 0